export const SUPPORTS_OBJECT_KEYS = "keys" in Object;
